import React from 'react';
import ServiceCard from './ServiceCard';
import { services } from '../mock';

const Services = () => {
  const total = services.length;
  return (
    <section id="services" className="bg-[#f4efe6] py-24 md:py-32">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="max-w-2xl fade-up">
          <div className="eyebrow label-caps mb-6">How I can help</div>
          <h2 className="font-serif text-[#201d1a] text-[38px] md:text-[54px] leading-[1.05] tracking-tight">
            One steady pair of hands across the whole business.
          </h2>
          <p className="mt-6 text-[16px] leading-[1.7] text-[#4a423b] max-w-[560px]">
            Management and operations sit at the centre — everything else is here to keep the wheels turning while you focus on the work that matters.
          </p>
        </div>

        <div className="mt-16 border-t border-l border-[#d9d0c1] fade-up">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
            {services.map((service, idx) => (
              <ServiceCard
                key={service.num}
                service={service}
                isLastCol={(idx + 1) % 3 === 0}
                isLastRow={idx >= total - 3}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
